import { UserData } from '../api/smartbestbuys-api/data/data-types'

export const getUserFullNameById = (userId: number, users: UserData[]) => {
  const user = users.find((u) => u.id === userId)
  return user ? user.firstName + ' ' + user.lastName : 'unknown'
}
